import React from 'react';
import PropTypes from 'prop-types';

import {
    FIELD_VALIDATION_ERROR_TYPES,
    MAX_MOD_VERSION_LENGTH,
    MIN_MOD_VERSION_LENGTH,
} from '../../../utils/constants'

import Caption from '../../Caption/Caption';
import EditLabelError from '../EditLabelError/EditLabelError';
import EditLabelText from '../EditLabelText/EditLabelText';
import Input from '../../Input/Input';

import {
    FIELD_MAX_LIMIT_EXCEED_ERROR,
    FIELD_MIN_LIMIT_EXCEED_ERROR,
} from '../../../translations'

import {
    EDIT_MOD_VERSION_LABEL,
    EDIT_MOD_VERSION_LABEL_TEXT,
} from './translations'

import styles from './EditModVersion.module.css'

export default class EditModVersion extends React.PureComponent {
    static propTypes = {
        externalError: PropTypes.oneOf([
            FIELD_VALIDATION_ERROR_TYPES.MAX_LIMIT,
            FIELD_VALIDATION_ERROR_TYPES.MIN_LIMIT,
        ]),
        externalValue: PropTypes.string,
        isSecondary: PropTypes.bool,
        onValueChange: PropTypes.func.isRequired,
    }

    constructor() {
        super()

        this.state = {
            errorType: null,
            value: '',
        }
    }

    UNSAFE_componentWillMount() {
        if (this.props.externalValue) {
            this.setState({
                value: this.props.externalValue,
            })
        }
    }

    handleValueChange = (value) => {
        let errorType = null

        if (value.length > MAX_MOD_VERSION_LENGTH) {
            errorType = FIELD_VALIDATION_ERROR_TYPES.MAX_LIMIT
        } else if (value.length < MIN_MOD_VERSION_LENGTH) {
            errorType = FIELD_VALIDATION_ERROR_TYPES.MIN_LIMIT
        }

        this.setState({ errorType, value })
        this.props.onValueChange(value, errorType)
    }

    renderError() {
        const errorToMessagesMapping = {
            [FIELD_VALIDATION_ERROR_TYPES.MAX_LIMIT]: FIELD_MAX_LIMIT_EXCEED_ERROR(MAX_MOD_VERSION_LENGTH),
            [FIELD_VALIDATION_ERROR_TYPES.MIN_LIMIT]: FIELD_MIN_LIMIT_EXCEED_ERROR(MIN_MOD_VERSION_LENGTH),
        }
        return this.state.errorType ? (
            <EditLabelError message={errorToMessagesMapping[this.state.errorType]} />
        ) : null
    }

    render() {
        return (
            <div className={styles.base}>
                <div className={styles.label}>
                    <Caption
                        isLarge={!this.props.isSecondary}
                        isRequired
                        isError={!!this.props.externalError}
                    >
                        {EDIT_MOD_VERSION_LABEL}
                    </Caption>
                    <EditLabelText message={EDIT_MOD_VERSION_LABEL_TEXT} />
                    {this.renderError()}
                </div>
                <div className={styles.field}>
                    <Input
                        value={this.state.value}
                        isError={!!this.props.externalError}
                        onChange={this.handleValueChange}
                    />
                </div>
            </div>
        )
    }
}
